// extracted by mini-css-extract-plugin
module.exports = {"root":"IconArrowNavigation_root__1PnvO"};